module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-continer"
  }, [_c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-light bg-faded navbarzindex navbar-min-height"
  }, [_c('div', {
    staticClass: "row w-100 align-items-center",
    class: _vm.windowWidth > 1920 ? 'container-fluid custom-container' : ''
  }, [_c('div', {
    staticClass: "col-5 d-flex"
  }, [_c('div', {
    staticClass: "hamburger-icon"
  }, [_c('div', {
    staticClass: "mt-1",
    staticStyle: {
      "height": "100%"
    },
    on: {
      "click": function($event) {
        _vm.openSideNav()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://prod-img.thesouledstore.com/static/hamburger-bleack.svg",
      "alt": "Logo"
    }
  })]), _vm._v(" "), _c('SideNav', {
    attrs: {
      "isOpen": _vm.showSideNav,
      "isDesktop": _vm.isDesktop
    },
    on: {
      "close": function($event) {
        _vm.showSideNav = false
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-list"
  }, [_c('div', {}, [_c('ul', {
    staticClass: "top_nav"
  }, [(true) ? _c('li', {
    class: [_vm.webcategory === 'men' ? 'activeCat' : '']
  }, [_c('router-link', {
    attrs: {
      "to": "/men"
    }
  }, [_vm._v("MEN")])], 1) : _vm._e(), _vm._v(" "), (true) ? _c('li', {
    class: [_vm.webcategory === 'women' ? 'activeCat' : '']
  }, [_c('router-link', {
    attrs: {
      "to": "/women"
    }
  }, [_vm._v("WOMEN")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isSelectedCountryIndia) ? _c('li', {
    class: [_vm.webcategory === 'kids' ? 'activeCat' : '']
  }, [_c('router-link', {
    attrs: {
      "to": "/kids"
    }
  }, [_vm._v("Kids")])], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedCountryIndia) ? _c('li', {
    class: [_vm.webcategory === 'sneakers' ? 'activeCat' : '']
  }, [_c('router-link', {
    attrs: {
      "to": "/sneakers"
    }
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderForSneakersWebCategory.description))])], 1) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "icon-container d-flex justify-content-center mt-1"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [(_vm.isExclusive) ? _c('img', {
    attrs: {
      "src": "https://prod-img.thesouledstore.com/static/Member-tss-logo.gif",
      "alt": "Logo"
    }
  }) : _c('img', {
    staticStyle: {
      "margin-top": "3px"
    },
    attrs: {
      "src": "https://prod-img.thesouledstore.com/static/non-member-logo2.gif",
      "alt": "Logo"
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "right-content"
  }, [_c('ul', {
    staticClass: "navbar-nav"
  }, [_c('li', {
    staticClass: "mr-1"
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('div', {
    staticClass: "search new-search"
  }, [_c('autocomplete', {
    attrs: {
      "trigger": _vm.trigger,
      "searchTerm": _vm.value,
      "callerComp": _vm.callerComp,
      "isNewSearch": true
    }
  })], 1)])]), _vm._v(" "), (_vm.authStatus) ? _c('li', {
    staticClass: "nav-item navicon track-order"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle track-hover",
    attrs: {
      "id": "navbarDropdownuser",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": _vm.trackOrder
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "hover-label"
  }, [_vm._v("Track Order")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item navicon dropdown iconlink"
  }, [(_vm.authStatus) ? _c('a', {
    staticClass: "nav-link naviconTitle dropdown-toggle",
    attrs: {
      "href": "javascript:void(0)",
      "id": "navbarDropdownuser",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "title": _vm.userAcc.getuserName
    },
    on: {
      "click": function($event) {
        _vm.gotoUrl('orders')
      }
    }
  }, [_vm._m(1), _vm._v(" "), ((_vm.getPlatformCounts('TSS_MONEY') || _vm.getPlatformCounts('TSS_POINTS')) > 0) ? _c('div', {
    staticClass: "count",
    staticStyle: {
      "top": "11px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.getPlatformCounts('TSS_MONEY') + _vm.getPlatformCounts('TSS_POINTS')) + "\n                          ")]) : _vm._e()]) : _c('span', {
    staticClass: "nav-link noTdropdown",
    on: {
      "click": _vm.redirectToLogin
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "https://prod-img.thesouledstore.com/static/mship-profile.svg",
      "alt": "wishlist",
      "width": "25",
      "height": "25"
    }
  })])]), _vm._v(" "), (_vm.authStatus) ? _c('div', {
    staticClass: "dropdown-menu right",
    attrs: {
      "aria-labelledby": "navbarDropdownuser"
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item '+this.$router.currentRoute+'",
    attrs: {
      "to": "/orders"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.profileEventsHandler('Orders')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), (_vm.isSelectedCountryIndia) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/my-gift-voucher"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.profileEventsHandler('Gift Vouchers')
      }
    }
  }, [_vm._v("Gift Vouchers")])]) : _vm._e(), _vm._v(" "), (_vm.isSelectedCountryIndia) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/my-reward-points/money"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.profileEventsHandler('TSS Money')
      }
    }
  }, [_vm._v("\n                              TSS Money\n                            ")]), _vm._v(" "), (_vm.getPlatformCounts('TSS_MONEY') > 0) ? _c('span', {
    staticClass: "badge badge-danger rounded-circle",
    attrs: {
      "title": "Expiring soon"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.getPlatformCounts('TSS_MONEY')) + "\n                            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSelectedCountryIndia) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/my-reward-points/points"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.profileEventsHandler('TSS Points')
      }
    }
  }, [_vm._v("\n                              TSS Points\n                            ")]), _vm._v(" "), (_vm.getPlatformCounts('TSS_POINTS') > 0) ? _c('span', {
    staticClass: "badge badge-danger rounded-circle",
    attrs: {
      "title": "Expiring soon"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.getPlatformCounts('TSS_POINTS')) + "\n                            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSelectedCountryIndia) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/my-saved-cards"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.profileEventsHandler('Saved Cards')
      }
    }
  }, [_vm._v("Saved Cards")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item pointer profile",
    class: this.$route.path === '/profile' ? 'profileactive' : '',
    on: {
      "click": function($event) {
        _vm.sideMenu('/profile')
      }
    }
  }, [_c('span', [_vm._v("Profile")])]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/faqs"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.profileEventsHandler('FAQs')
      }
    }
  }, [_vm._v("FAQs")])]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/contact-us"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.profileEventsHandler('Contact Us')
      }
    }
  }, [_vm._v("Contact Us")])]), _vm._v(" "), (_vm.user.user_type == 3) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/artwork-sale"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.profileEventsHandler('Artwork Sales')
      }
    }
  }, [_vm._v("Artwork Sales")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropdown-item pointer ",
    on: {
      "click": _vm.handlelogout
    }
  }, [_vm._v("Logout")])], 1) : _vm._e()]), _vm._v(" "), (!_vm.disableWishlist) ? _c('li', {
    staticClass: "nav-item navicon"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "id": "navbarDropdownuser",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": _vm.wishlistEvent
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.wishlistCount > 0) ? _c('div', {
    staticClass: "count",
    staticStyle: {
      "top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.wishlistCount || _vm.wishlistLength))]) : (_vm.wishlistLength > 0 && _vm.authStatus) ? _c('div', {
    staticClass: "count",
    staticStyle: {
      "top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.wishlistLength))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item navicon"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "id": "navbarDropdownuser",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "click": _vm.cartEvent
    }
  }, [_vm._m(3), _vm._v(" "), (_vm.cartcount > 0) ? _c('div', {
    staticClass: "count",
    staticStyle: {
      "top": "11px"
    }
  }, [_vm._v(_vm._s(_vm.isMystery ? _vm.cartcount - 1 : _vm.cartcount))]) : (_vm.cartLength > 0 && _vm.authStatus) ? _c('div', {
    staticClass: "count",
    staticStyle: {
      "top": "11px"
    }
  }, [_vm._v(_vm._s(_vm.isMystery ? _vm.cartLength - 1 : _vm.cartLength))]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "https://prod-img.thesouledstore.com/static/trackorder.svg",
      "alt": "wishlist",
      "width": "28",
      "height": "28"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "https://prod-img.thesouledstore.com/static/mship-profile.svg",
      "alt": "wishlist",
      "width": "25",
      "height": "25"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "https://prod-img.thesouledstore.com/static/mship-wishlist.svg",
      "alt": "wishlist",
      "width": "23",
      "height": "23"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    staticClass: "headercart",
    attrs: {
      "src": "https://prod-img.thesouledstore.com/static/shopping-cart.svg",
      "alt": "Cart",
      "width": "25",
      "height": "25"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a2dc9ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/newAppNav.vue
// module id = 2472
// module chunks = 45